import cx from 'classnames';

import { makeStyles } from '@mui/styles';

import { isCurrentPath } from '@openclassrooms/routing';
import MainHeaderNavigationLink from '../MainHeaderNavigationLink';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ spacing, palette, breakpoints }) => ({
    root: {
      padding: spacing(1.5),
      [breakpoints.down('lg')]: {
        padding: spacing(1),
      },
    },
    active: {
      borderBottom: `3px solid ${palette.primary.main}`,
    },
    navLink: {
      whiteSpace: 'nowrap',
      padding: [[spacing(1), 0]],
      textDecoration: 'none',
      fontSize: 16,
    },
  })
);

const MainHeaderNavigationLinkWrapper = ({
  path = '',
  shouldMatchPathname = false,
  ...otherProps
}) => {
  const classes = useStyles();

  const doesLocationMatch = isCurrentPath(path, shouldMatchPathname);

  return (
    <div className={classes.root}>
      <MainHeaderNavigationLink
        {...otherProps}
        path={path}
        className={cx(classes.navLink, { [classes.active]: doesLocationMatch })}
      />
    </div>
  );
};

export default MainHeaderNavigationLinkWrapper;
